


<div mat-dialog-title class="cust-modal-title">
    <h2 class="m-0">Select Slot</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>

<mat-dialog-content>
  <div *ngIf="loader" style="width: 600px;">

  </div>
    <div class="" style="    max-width: 600px;">
     
    
        <div class="body_banner_section" *ngIf="!loader">
          <div class="">
            <div class="dashboard_booking_list">
              
              <div class="booking_date_list cust_chip">
                <div *ngIf="todayData.length != 0">
                  <div class="booking_date_list">
                    <div
                      class="list_date_time"
                      
                      *ngFor="let item of todayData; let i = index"
                      [ngClass]="{
                        selected:
                            item.isSelected == 1,
                        active:
                          item.status == '1' &&
                          item.appointmentsCount >= 0 &&
                          item.appointmentsCount < 6,
                        yellow:
                          item.status == '1' &&
                          item.appointmentsCount > 5 &&
                          item.appointmentsCount < 11,
                        red: item.status == '1' && item.appointmentsCount > 10
                      }"
                      (click)="clickTodaytime(item)"
                    >
                      <span
                        >{{ tConv24(item.startTime) }} -
                        {{ tConv24(item.endTime) }}</span
                      >
                    </div>
                  </div>
                </div>
        
                <div
                  class="placeholder-text"
                  *ngIf="todayData.length == 0"
                >
                  <section class="error-container">
                    <div class="not-valid-text">
                      <!-- <div class="mb-3_t">
                        <ngx-mat-timepicker #pickerA (timeSet)="onTimeSelected($event)"></ngx-mat-timepicker>
                      </div> -->
                      
        <mat-form-field class="w-100" appearance="outline" (click)="pickerA.open()" style="display: none;">
          <mat-label>Select Time</mat-label>
          <input matInput
                 name="selected_time_A"
                 [ngxMatTimepicker]="pickerA"
                 readonly
                 [(ngModel)]="selectedTime"/>
          <mat-icon matSuffix style="margin-right: 4px;">
            access_time
          </mat-icon>
      </mat-form-field>
      <ngx-mat-timepicker #pickerA (timeSet)="onTimeSelected($event)" (closed)="onClosed($event)"></ngx-mat-timepicker>
                    </div>
                  </section>
                </div>
        
              </div>
              
            </div>
        
        
        
          </div>
        </div>
        </div>
</mat-dialog-content>
   
<!--     
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>Cancel</button>
        <button
          mat-flat-button
          color="accent"
         
          (click)="onSave()"
        >
          Confirm
        </button>
      </mat-dialog-actions> -->
    
   
    <!-- JS here -->
    <script src="assets/js/jquery-1.12.4.min.js"></script>
    <script src="assets/js/popper.min.js"></script>
    <script src="assets/js/bootstrap.min.js"></script>
    <script src="assets/js/modernizr-3.5.0.min.js"></script>
    <script src="assets/js/jquery.meanmenu.min.js"></script>
    <!-- ma5menu -->
    <!-- <script src="assets/js/ma5-menu.min.js"></script> -->
    <script src="assets/pluging/owl.carousel.min.js"></script>
    <script>
        $('.owl-carousel').owlCarousel({
            loop: false,
            margin: 10,
            autoplay: true,
            autoplayTimeout: 3000,
            dots: true,
            autoplayHoverPause: true,
            nav: false,
            responsive: {
                0: {
                    items: 2
                },
                600: {
                    items: 3
                },
                1000: {
                    items: 3
                }
            }
        })
    </script>
    <script>
        $(function() {
            $(".dropbtn").click(
                function() {
                    $('.dropdown-menu', this).stop(true, true).fadeIn("fast");
                    $(this).toggleClass('open');
                    $('b', this).toggleClass("caret caret-up");
                },
                function() {
                    $('.dropdown-menu', this).stop(true, true).fadeOut("fast");
                    $(this).toggleClass('open');
                    $('b', this).toggleClass("caret caret-up");
                });
        });
    </script>
    <script>
        // meanmenu
        $('#mobile-menu').meanmenu({
            meanMenuContainer: '.mobile-menu',
            meanScreenWidth: "992"
        });
    
        $('.info-bar').on('click', function() {
            $('.extra-info').addClass('info-open');
        })
    
        $('.close-icon').on('click', function() {
            $('.extra-info').removeClass('info-open');
        })
    </script>
    <!-- Call the script -->
    <script>
        $(document).ready(function() {
            ma5menu({
                menu: '.site-menu',
                activeClass: 'active',
                position: 'left',
            });
        });
    </script>
    